import i18next from 'i18next';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { RootState } from 'reducers';
import { createConfirmation } from 'actions/Confirmation';

type AdditionalDataType = 'manualEntry' | 'tipping';

export const askForAdditionalDataPerType = (type: AdditionalDataType) => async (
  dispatch: ThunkDispatch<RootState, unknown, Action>,
) => {
  const result = await new Promise((res, rej) =>
    dispatch(
      createConfirmation(res, rej, {
        title: i18next.t(`payment:cardPayments.adyen.titles.${type}`),
        body: i18next.t(`payment:cardPayments.adyen.messages.${type}`),
        automaticAction: 'reject',
        automaticActionAfter: 7000,
      }),
    ),
  )
    .then(() => true)
    .catch(() => false);
  return result;
};
